import { useBrand } from '@bnnvara/brand';
import { GridItem } from '@bnnvara/grids';
import { Menu, MenuItem } from '@bnnvara/menu';
import { useRouter } from 'next/router';
import React from 'react';

import { FetchCatalogNavigation } from '../../../api/queries/catalog.gql';
import Link from '../../Link';
import PageQuery from '../../PageQuery';

const CatalogNavigation = () => {
  const brand = useBrand();
  const {
    query: { slug, index: currentIndex },
  } = useRouter();

  return (
    <GridItem columnEndSm="span 12" columnEndMd="span 12" columnEndLg="span 12">
      <PageQuery
        query={FetchCatalogNavigation}
        variables={{
          brandSlug: brand.slug,
          slug,
        }}
      >
        {({ data }) => {
          const {
            brand: {
              catalog: { navigation },
            },
          } = data;

          const isActiveIndex = (index) => currentIndex === index.toLowerCase();

          if (navigation.length === 0) {
            return null;
          }

          return (
            <Menu variant="large">
              {navigation.map((item) => {
                const route =
                  item.index.toLowerCase() === '0-9'
                    ? `catalogus/${slug}/09`
                    : `catalogus/${slug}/${item.index.toLowerCase()}`;

                const isActive = isActiveIndex(item.index);

                return (
                  <MenuItem isActive={isActive} key={item.index}>
                    {item.enabled ? (
                      <Link href={route}>{item.index}</Link>
                    ) : (
                      <span>{item.index}</span>
                    )}
                  </MenuItem>
                );
              })}
            </Menu>
          );
        }}
      </PageQuery>
    </GridItem>
  );
};

export default CatalogNavigation;
